import { Outlet } from "react-router-dom";
import { ProviderListMembro } from "./context/ListMembros";
import ContainerAssociarMembroPg from "./container";

export default function AssiciarMembroPg() {
  return (
    <ProviderListMembro>
      <>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerAssociarMembroPg />
        </div>
        <Outlet />
      </>
    </ProviderListMembro>
  )
}
